import { ApolloLink, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

import { Toaster } from '@grupoboticario/flora-react'

import { getGraphqlApi } from '@/utils/envUtils'
import { businessUnit } from '@/utils/themes/theme'

interface ErrorCheckerData {
  statusCode?: number
  message?: string
}

const errorCheckerLink = new ApolloLink((operation, forward) =>
  forward(operation).map((data) => {
    const stringData = JSON.stringify(data)
    const statusCodeRegex = (stringData || '').match(/"statusCode":(?<statusCode>\d*)/)
    const messageRegex = (stringData || '').match(/"message":"(?<message>.*?)"/)
    return statusCodeRegex &&
      Number.parseInt(statusCodeRegex?.groups?.statusCode ?? '0') &&
      Number.parseInt(statusCodeRegex?.groups?.statusCode ?? '0') >= 400
      ? {
          ...data,
          errors: [{ customMessage: messageRegex?.groups?.message || null }]
        }
      : data
  })
)

const authLink = setContext((_, { headers }: { headers: Record<string, string> }) => {
  return {
    headers: {
      ...headers,
      Authorization: localStorage.getItem('backoffice-app-jwt'),
      'x-businessUnit': businessUnit(window?.location?.hostname),
      'x-channel': 'backoffice'
    }
  }
})

const errorLink = onError((error) => {
  const graphQLError = error?.graphQLErrors?.[0] as (ErrorCheckerData & { customMessage?: string }) | undefined
  Toaster.notify({
    kind: 'error',
    description:
      graphQLError?.customMessage || 'Parece que estamos com problemas ao se comunicar com os nossos serviços.'
  })
})

const httpLink = createHttpLink({
  uri: getGraphqlApi(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const link = ApolloLink.from([errorLink, authLink, errorCheckerLink, httpLink])

export default link
